import { render, staticRenderFns } from "./ConfirmAccount.vue?vue&type=template&id=265f42f4&"
import script from "./ConfirmAccount.vue?vue&type=script&lang=js&"
export * from "./ConfirmAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports